module.exports = __webpack_public_path__ + "5.0.2/img/p1.a350f612.jpg";